export default __webpack_public_path__ + "static/media/mon_256.86daa72b.png";